import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { industryPages } from "../data/industryPages";

export default function WebdesignFuerAerzte() {
  return <ContentPageTemplate {...industryPages.aerzte} />;
}
